// removed by extract-text-webpack-plugin
module.exports = {"root":"_3k_uE","bio":"qYcjo","bioContent":"_3_c6P","identities":"_27Vjb","navInactive":"_1cnSC","talks":"_24CjK","events":"_1_mS8"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/People/pages/Show.sass
// module id = ./src/modules/People/pages/Show.sass
// module chunks = 6